import { ButtonGroup, FormControl, InputLabel, MenuItem, Select, SelectChangeEvent } from "@mui/material";
import { Token } from "../types/content-editor-types";

type Props = {
    tokens: Token[];
    onCommand: (command: string, argument?: string) => void;
};

const TokenSelector = ({ tokens, onCommand }: Props) => {
    const handleInsertToken = (e: SelectChangeEvent) => {
        onCommand('insertHTML', `#${e.target.value}`);
        e.preventDefault();
        e.stopPropagation();
    };
    
    return (
        <>
            {tokens.length > 0 && (
                <ButtonGroup disableElevation color="inherit" variant="contained" size="small" sx={{ mr: 2 }}>
                    <FormControl size="small">
                        <InputLabel aria-label="token-select">Token</InputLabel>
                        <Select id='token-select' label="Token" value="" size="small" onChange={handleInsertToken}>
                            {tokens.map(t => (
                                <MenuItem key={t.value} value={t.value}>
                                    {t.text}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </ButtonGroup>
            )}
        </>
    );
};

export default TokenSelector;
